module.exports = __webpack_public_path__ + "img/icon-folder-upload.fe312924.svg";